import * as React from "react";
import {
  OfferContainer,
  description,
  title,
  teaserLink,
  button,
  links,
  offerContent,
  badge,
  content,
} from "./PageOfferList.module.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { getImage } from "gatsby-plugin-image";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

export const OfferListContainer: React.FC<any> = (props) => {
  return (
    <Container fluid="sm" className={`${OfferContainer} p-0`}>
      {props.children}
    </Container>
  );
};

export const OfferListImage: React.FC<any> = (props) => {
  return (
    <GatsbyImage image={props.image} alt={props.alt} className="col-lg-6" />
  );
};

export const OfferList: React.FC<any> = (props) => {
  const rateCode = props.offer.field_promo_code;
  const image = props.offer.relationships.field_teaser_image
    ? getImage(
        props.offer.relationships.field_teaser_image.relationships
          .field_media_image.gatsbyImage as any
      )
    : null;
  return (
    <Row key={props.offer.id} className="g-0 mb-4">
      {image && <OfferListImage image={image} alt={props.offer.title} />}
      <Col
        lg={6}
        className={`${offerContent} border rounded-bottom p-2 p-lg-4`}
      >
        <div className={content}>
          {props.offer.field_subtitle && (
            <Badge className={badge}>{props.offer.field_subtitle}</Badge>
          )}
          <h4 className={title}>{props.offer.title}</h4>
          <p
            className={description}
            dangerouslySetInnerHTML={{
              __html: props.offer.description?.summary,
            }}
          />
          <div className={links}>
            {rateCode && (
              <Button
                data-rate={rateCode}
                data-offername={props.offer.title}
                id={"book-now-button-" + rateCode.toLowerCase()}
                onClick={props.handleBookNow}
                aria-label={`Book Now for ${props.offer.title}`}
                className={button}
              >
                Book Now
              </Button>
            )}
            {!props.offer.field_external_link && (
              <Link
                aria-label={`Learn More for ${props.offer.title}`}
                to={props.offer.path.alias}
                className={teaserLink}
                id={`offer-teaser-internal-link-${rateCode}`}
              >
                Learn More
              </Link>
            )}
            {props.offer.field_external_link && (
              <a
                href={props.offer.field_external_link.url}
                className={teaserLink}
                target="_blank"
                rel="noreferrer"
              >
                {props.offer.field_external_link.title}
              </a>
            )}
          </div>
        </div>
      </Col>
    </Row>
  );
};
